import React, { createContext, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import useCanonicalNavigate, { cancelPendingCanonicalNavigation } from '../hooks/useCanonicalNavigate';

export const ProfilePreviewContext = createContext(null);

export function profileIdFromTarget(to) {
  const pathname = typeof to === 'string' ? to : to?.pathname;
  const match = typeof pathname === 'string' && pathname.match(/^\/profile\/([^/?#]+)\/?(?:[?#].*)?$/);
  if (!match) return null;
  try { return decodeURIComponent(match[1]); } catch { return null; }
}

// Canonical URL replacements and browser/deep links continue to load the page.
// User-initiated profile navigation first opens the shared preview.
export function useProfileNavigate() {
  const navigate = useCanonicalNavigate(), preview = useContext(ProfilePreviewContext);
  return useCallback((to, options) => {
    const id = profileIdFromTarget(to);
    if (id && preview && !options?.replace) {
      cancelPendingCanonicalNavigation();
      return preview({ userId: id });
    }
    return options === undefined ? navigate(to) : navigate(to, options);
  }, [navigate, preview]);
}

export function ProfileLink({ to, onClick, target, ...props }) {
  const preview = useContext(ProfilePreviewContext);
  return <Link {...props} to={to} target={target} onClick={event => {
    onClick?.(event);
    const id = profileIdFromTarget(to);
    if (!event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!target || target === '_self') && id && preview) {
      event.preventDefault();
      cancelPendingCanonicalNavigation();
      preview({ userId: id });
    }
  }}/>;
}
